import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageScrollerFooterDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignSelf: "center",
        flexShrink: 0,
        width: "100%"
    }
});

export const useStyles = ({
    shapeConfigs,
    spaces
}: MessageScrollerFooterDynamicStyleType) => {
    const styles = {
        container: {
            paddingHorizontal: spaces.spacingMd,
            maxWidth: shapeConfigs.chatWidth,
            paddingBottom: spaces.spacingMd,
            paddingTop: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
